import React from 'react';

export const TrailerVideoEmbed = () => (
  <div className="videoWrapper">
    <iframe
      className="videoEmbed"
      src="https://www.youtube.com/embed/kgNsLdg06ew"
      title="YouTube video player"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    ></iframe>
  </div>
);
